import { AChartComponent } from "../../achart/achart.component";

import { NgbModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

import { SavedStrategiesModalComponent } from "./SavedStrategiesModal.component";

import { FormGroup } from "@angular/forms";
import { MobileSavedStrategiesModalComponent } from "../mobile-saved-strategies-modal/mobile-saved-strategies-modal.component";

export function ShowSavedStrategiesModal(achart: AChartComponent[], modalService: NgbModal, mobileMode = "desktop") {
    const mobile = mobileMode != "desktop";
    const component = mobile ? MobileSavedStrategiesModalComponent : SavedStrategiesModalComponent;
    const windowClass = "dark-modal" + (mobile ? " mobile" : "");
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: windowClass,
        size: "sm"
    };
    let m: NgbModalRef = modalService.open(component, opt);
    (<SavedStrategiesModalComponent>m.componentInstance).initForm(achart);

    m.result
        .then((formGroup: FormGroup) => {})
        .catch(reason => {
            console.error(reason);
        });
}

export function ShowAddNewStrategyModal(achart: AChartComponent[], modalService: NgbModal, mobileMode = "desktop") {
    const mobile = mobileMode != "desktop";
    const component = mobile ? MobileSavedStrategiesModalComponent : SavedStrategiesModalComponent;
    const windowClass = "dark-modal" + (mobile ? " mobile" : "");
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: windowClass,
        size: "sm"
    };
    let m: NgbModalRef = modalService.open(component, opt);
    (<SavedStrategiesModalComponent>m.componentInstance).initForm(achart, "addNewStrategy", "");

    m.result
        .then((formGroup: FormGroup) => {})
        .catch(reason => {
            console.error(reason);
        });
}

export function ShowDeleteModal(
    achart: AChartComponent[],
    modalService: NgbModal,
    deletingStrategyId: string,
    mobileMode = "desktop"
) {
    const mobile = mobileMode != "desktop";
    const component = mobile ? MobileSavedStrategiesModalComponent : SavedStrategiesModalComponent;
    const windowClass = "dark-modal" + (mobile ? " mobile" : "");
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: windowClass,
        size: "sm"
    };
    let m: NgbModalRef = modalService.open(component, opt);
    (<SavedStrategiesModalComponent>m.componentInstance).initForm(achart, "deleteStrategy", deletingStrategyId);

    m.result
        .then((formGroup: FormGroup) => {})
        .catch(reason => {
            console.error(reason);
        });
}

export function ShowSaveModal(
    achart: AChartComponent[],
    modalService: NgbModal,
    saveStrategyId: string,
    mobileMode = "desktop"
) {
    const mobile = mobileMode != "desktop";
    const component = mobile ? MobileSavedStrategiesModalComponent : SavedStrategiesModalComponent;
    const windowClass = "dark-modal" + (mobile ? " mobile" : "");
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: windowClass,
        size: "sm"
    };
    let m: NgbModalRef = modalService.open(component, opt);
    (<SavedStrategiesModalComponent>m.componentInstance).initForm(achart, "saveStrategy", saveStrategyId);

    m.result
        .then((formGroup: FormGroup) => {})
        .catch(reason => {
            console.error(reason);
        });
}

export function ShowRenameStrategyModal(
    achart: AChartComponent[],
    modalService: NgbModal,
    renameStrategyId: string,
    mobileMode = "desktop"
) {
    const mobile = mobileMode != "desktop";
    const component = mobile ? MobileSavedStrategiesModalComponent : SavedStrategiesModalComponent;
    const windowClass = "dark-modal" + (mobile ? " mobile" : "");
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: windowClass,
        size: "sm"
    };
    let m: NgbModalRef = modalService.open(component, opt);
    (<SavedStrategiesModalComponent>m.componentInstance).initForm(achart, "renameStrategy", renameStrategyId);

    m.result
        .then((formGroup: FormGroup) => {})
        .catch(reason => {
            console.error(reason);
        });
}
